export const PermissionGroupUserXRefAllTR={
PeGUID:{en:'PeGUID',cs:'PeGUID',dataType:'number',format:'#0',required:true},
PeGUPerGID:{en:'PeGUPerGID',cs:'PeGUPerGID',dataType:'number',format:'#0',required:true},
PeGUUserID:{en:'PeGUUserID',cs:'PeGUUserID',dataType:'number',format:'#0',required:true},
PerGIsActive:{en:'Active',cs:'',dataType:'boolean'},
UserFullName:{en:'Full Name',cs:'',dataType:'string',maxLength:101}
}